import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { Fragment, useMemo } from 'react';
import { Element } from 'react-scroll';
import { Field } from 'redux-form';
import { propArrayShape, propNumber, propShape, propStr, } from '../../../../../../helpers/custom-prop-types';
import { getFormValue } from '../../../../../../helpers/form';
import SolutionError from '../Error';
const MiddleCategoryCheckBox = (props) => {
    const { formFields, max, name, solutionLargeClasses, solutionMiddleClasses } = props;
    const rawValues = getFormValue(formFields, name);
    const checkedIdList = useMemo(() => Object.keys(rawValues || [])
        .filter((key) => rawValues[key] === true)
        .map((key) => key), [rawValues]);
    const viewClasses = useMemo(() => solutionLargeClasses.map((solutionLargeClass) => (Object.assign(Object.assign({}, solutionLargeClass), { middleClasses: solutionMiddleClasses.filter(({ solutionLargeClassId }) => solutionLargeClassId === solutionLargeClass.id) }))), [solutionLargeClasses, solutionMiddleClasses]);
    const error = useMemo(() => {
        const isTouch = _.get(formFields, `fields.${name}_list.touched`);
        if (isTouch) {
            return _.get(formFields, `syncErrors.${name}_list`);
        }
        return '';
    }, [formFields, name]);
    return (_jsxs(Element, Object.assign({ className: 'multiple-checkbox bg_gray', name: `${name}_view` }, { children: [_jsx("dl", Object.assign({ className: 'mb1' }, { children: viewClasses.map((viewClass) => (_jsxs(Fragment, { children: [_jsx("dt", { children: viewClass.name }, viewClass.id), _jsx("dd", { children: viewClass.middleClasses.map((middleClass) => {
                                const isDisabled = max &&
                                    checkedIdList.length >= max &&
                                    !checkedIdList.includes(middleClass.id.toString());
                                return (_jsxs("div", Object.assign({ className: isDisabled ? 'is-disabled' : '' }, { children: [_jsx(Field, { className: 'mdc-checkbox__native-control', component: 'input', disabled: isDisabled, id: `${name}_${middleClass.id}`, name: `${name}[${middleClass.id}]`, type: 'checkbox', value: middleClass.id }), ' ', _jsx("label", Object.assign({ htmlFor: `${name}_${middleClass.id}` }, { children: middleClass.name }))] }), middleClass.id));
                            }) })] }, viewClass.id))) })), _jsx(SolutionError, { error: error })] })));
};
MiddleCategoryCheckBox.propTypes = {
    formFields: propShape().isRequired,
    max: propNumber(),
    name: propStr().isRequired,
    solutionLargeClasses: propArrayShape().isRequired,
    solutionMiddleClasses: propArrayShape().isRequired,
};
MiddleCategoryCheckBox.defaultProps = {
    max: undefined,
};
export default MiddleCategoryCheckBox;
